exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".reviewsList--1yJ6l{display:flex;flex-direction:column;gap:20px}", ""]);

// Exports
exports.locals = {
	"reviewsList": "reviewsList--1yJ6l"
};